import React from "react";
import DoctorProfileComplete from "../DoctorSignup/DoctorProfileComplete/DoctorProfileComplete";
import useHospitalProviderRole from "./useHospitalProviderRole";

export default function HospitalProfileComplete() {
  useHospitalProviderRole();
  return <DoctorProfileComplete />;
}
